export default "__VITE_ASSET__COTp_Duv__"